import React from 'react';
import moment from 'moment';

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
};

export function getDataFromApi(url, body, method = 'POST') {
    return fetch(url, {
        method: method,
        headers: headers,
        body: body
    })
}

export function convertStringsToDates(array) {
    let disabled_days = [];
    if (array.length > 0) {
        array.forEach(day => {
            const disabledDay = new Date(day)
            disabledDay.setHours(12,0,0,0)
            disabled_days.push(disabledDay)
        });
    }
    return disabled_days;
}

export function getCurrentMonthPastDays(stopDate) {
    let startDate = moment(moment().startOf('month'))
    let dateArray = []
    stopDate = moment(stopDate)

    while (startDate.date() < stopDate.date()) {
        dateArray.push(moment(startDate).format('YYYY-MM-DD'))
        startDate = moment(startDate).add(1, 'days')
    }

    return dateArray.map(day => {
        const date = new Date(day)
        date.setHours(0,0,0,0)
        return date
    });
}

